import { BillingPlanDto } from '@shared/core/billing'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { ApiService } from 'src/services/api.service'
import { GetSubscriptionPlansDto } from 'src/services/billing.interface'

export const GET_SUBSCRIPTION_PLANS_CACHE_KEY = 'get-subscription-plans'

export function useSubscriptionPlans(params?: GetSubscriptionPlansDto, options?: UseQueryOptions<BillingPlanDto[]>) {
  const handleRetry = useHandleRetry()
  return useQuery([GET_SUBSCRIPTION_PLANS_CACHE_KEY, params], () => ApiService.Billing.getSubscriptionPlans(params), {
    staleTime: 300000,
    retry: handleRetry,
    ...options,
  })
}
